import {STORAGE} from "../storage";
import {EventBus} from "../EventBus";
import {dispatchAction} from "../state/dispatchAction";
import {setAuthenticated, setServerUrl, setSocketUrl, setSoketiUrl, setToken} from "../../reducers/configSlice";
import {getBaseUrlFromSocket} from "../helpers/getBaseUrlFromSocket";
export const setInitialAppData = async () => {
    const storageToken = await STORAGE.get("token")
    let storageBaseUrl = await STORAGE.get("baseUrl")
    const storageSoketiUrl = await STORAGE.get("soketiUrl")
    const storageSocketUrl = storageSoketiUrl && (storageSoketiUrl?.length > 0) ? null : await STORAGE.get("socketUrl");
    const storageDeviceUuid = await STORAGE.get("deviceUuid")

    if (!storageBaseUrl && storageSocketUrl) {
        storageBaseUrl = getBaseUrlFromSocket(storageSocketUrl)
        await STORAGE.set("baseUrl", storageBaseUrl)
    }

    if (storageBaseUrl && storageSocketUrl && (
        storageBaseUrl.includes('api.yarooms.com') ||
        storageBaseUrl.includes('api.eu.yarooms') ||
        storageBaseUrl.includes('api.ca.yarooms')
    )) {
        storageBaseUrl = getBaseUrlFromSocket(storageSocketUrl)
        await STORAGE.set("baseUrl", storageBaseUrl)
    }

    // Check if we have the essential data for authentication
    // Device UUID is optional but helpful for token refresh
    if (!storageToken || !storageBaseUrl || (!storageSocketUrl && !storageSoketiUrl)) {
        EventBus.emit('destroyInstance');
        return;
    }

    // Log if device UUID is missing (for debugging)
    if (!storageDeviceUuid) {
        console.warn('INIT_APP_DATA - Device UUID not found in storage, token refresh may not work');
    }

    dispatchAction(setServerUrl(storageBaseUrl))
    dispatchAction(setSocketUrl(storageSocketUrl))
    dispatchAction(setSoketiUrl(storageSoketiUrl))
    dispatchAction(setToken(storageToken))
    dispatchAction(setAuthenticated(true))
}
